import { Environment } from './environment.model';

export const environment: Environment = {
    name: 'dev',
};
